import { VideoCameraSlashIcon, WarningIcon } from '@moia-dev/pace-icons'
import { Button, Heading } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

export const NoVideoTile = ({ onRetry }: { onRetry?: () => void }) => {
  const { t } = useTranslation()
  return (
    <div
      css={theme => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.space.Space2,
        maxHeight: 300,
        padding: theme.spacing(2),
      })}
    >
      <VideoCameraSlashIcon
        css={theme => ({
          width: 120,
          height: 120,
          color: theme.semantic.ColorContentReduced,
        })}
      />
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <WarningIcon
          css={theme => ({
            width: 20,
            height: 20,
            marginRight: theme.spacing(1),
            color: theme.semantic.ColorContentReduced,
          })}
        />
        <Heading css={theme => ({ color: theme.semantic.ColorContentReduced })}>
          {t('adFleetMap_videoStreamErrorNotAvailable_caption')}
        </Heading>
      </div>
      {onRetry && (
        <div css={theme => ({ marginTop: theme.space.Space8 })}>
          <Button
            variant="primary"
            label={t('adFleetMap_videoStreamRetry_button')}
            onClick={onRetry}
          />
        </div>
      )}
    </div>
  )
}
